import getProvider from "./rpcProviderService";

let walletState = {
    provider: null,
    signer: null,
    isReadOnly: true,
    address: null
};

const getWallet = async () => {
    if (walletState.provider && walletState.address) {
        return { ...walletState };
    }
    
    if (typeof window !== 'undefined' && window.ethereum) {
        const provider = getProvider(false);
        const accounts = await provider.listAccounts();
        
        if (accounts.length > 0) {
            walletState.signer = provider.getSigner();
            walletState.address = accounts[0];
            walletState.isReadOnly = false;
            walletState.provider = provider;
        } else {
            walletState.provider = provider;
            walletState.isReadOnly = true;
        }
    } else {
        walletState.provider = getProvider(true);
        walletState.isReadOnly = true;
    }
    
    return { ...walletState };
};

export const connectWallet = async () => {
    if (typeof window === 'undefined' || !window.ethereum) {
        throw new Error("Please install MetaMask");
    }
    
    await window.ethereum.request({ method: 'eth_requestAccounts' });
    const provider = getProvider(false);
    const accounts = await provider.listAccounts();
    
    walletState.signer = provider.getSigner();
    walletState.address = accounts[0];
    walletState.isReadOnly = false;
    walletState.provider = provider;
    
    return { ...walletState };
};

export const disconnectWallet = async () => {
    walletState = {
        provider: null,
        signer: null,
        isReadOnly: true,
        address: null
    };
};

export const isWalletConnected = async () => {
    if (typeof window === 'undefined' || !window.ethereum) return false;
    const accounts = await window.ethereum.request({ method: 'eth_accounts' });
    return accounts.length > 0;
};

export default getWallet;